import { filterBy, State } from "@progress/kendo-data-query";
import { CompositeFilterDescriptor } from "@progress/kendo-data-query/dist/npm/filtering/filter-descriptor.interface";

// eslint-disable-next-line no-extend-native
Array.prototype.filterBy = function (dataState: State) {
  return filterBy(this, dataState.filter as CompositeFilterDescriptor);
};

export {};
